export default __webpack_public_path__ + "static/media/chuva.377175fb.svg";